import { render, staticRenderFns } from "./user-info-card.vue?vue&type=template&id=180f6cee&scoped=true&"
import script from "./user-info-card.vue?vue&type=script&lang=ts&"
export * from "./user-info-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f6cee",
  null
  
)

export default component.exports